import PublicationListsContent from "./PublicationListsContent";

export default PublicationListsContent;
